import { Directive, HostListener, Inject } from '@angular/core';
import { UrlService } from '@shared/services/url/url.service';

@Directive({
  selector: '[appRedirectFarefinder]'
})
export class RedirectFarefinderDirective {
  constructor(@Inject(UrlService) private _urlService: UrlService) {}

  @HostListener('click') onClick() {
    this._urlService.getFarefinderRedirectUrl().subscribe(url => window.open(url, '_blank'));
  }
}
